import React, { useEffect, useState } from "react";
const data = [
  {
    slogan: "Meeting industry standards for every product.",
    image: "/images/Hero/resized/4.jpg",
  },
  {
    slogan: "Trusted all over India and beyond.",
    image: "/images/Hero/resized/5.jpg",
  },
  {
    slogan: "40+years of excellence.",
    image: "/images/Hero/resized/3.jpg",
  },
];
const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const numImages = data.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % numImages);
    }, 8000);

    return () => clearInterval(interval);
  }, [numImages]);

  return (
    <div
      className="position-relative w-100 home-slider"
      style={{
        height: "85vh",
      }}
    >
      <div className="position-relative h-100 overflow-hidden w-100 pb-56-25">
        {data.map((imageData, index) => (
          <div
            key={index}
            className={`position-absolute top-0 start-0 w-100 h-100  transition-opacity ${
              index === currentIndex ? "opacity-100" : "opacity-0"
            }`}
            style={{ transition: "opacity 0.6s ease-in-out" }}
          >
            <img
              src={imageData.image}
              className="w-100 h-100 object-cover"
              alt={`Slide ${index + 1}`}
            />
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.6)",
              }}
            ></div>
          </div>
        ))}
      </div>
      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h2 className="text-white fw-bold">{data[currentIndex].slogan}</h2>
        </div>
      </div>
      <div className="position-absolute w-100 z-index-1 bottom-0">
        <svg
          className="waves"
          preserveAspectRatio="none"
          shapeRendering="auto"
          viewBox="0 24 150 40"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <path
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              id="gentle-wave"
            />
          </defs>
          <g className="moving-waves">
            <use
              fill="rgba(255,255,255,0.40)"
              x="48"
              xlinkHref="#gentle-wave"
              y="-1"
            />
            <use
              fill="rgba(255,255,255,0.35)"
              x="48"
              xlinkHref="#gentle-wave"
              y="3"
            />
            <use
              fill="rgba(255,255,255,0.25)"
              x="48"
              xlinkHref="#gentle-wave"
              y="5"
            />
            <use
              fill="rgba(255,255,255,0.20)"
              x="48"
              xlinkHref="#gentle-wave"
              y="8"
            />
            <use
              fill="rgba(255,255,255,0.15)"
              x="48"
              xlinkHref="#gentle-wave"
              y="13"
            />
            <use
              fill="rgba(255,255,255,0.95)"
              x="48"
              xlinkHref="#gentle-wave"
              y="16"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default Slider;
